/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00391 8.3514L13.2791 3.0762C14.2955 2.0598 15.6527 1.5 17.1011 1.5C18.5495 1.5 19.9067 2.0598 20.9231 3.0762C23.0303 5.184 23.0303 8.613 20.9231 10.7202L15.6479 15.9954L8.00391 8.3514Z" fill="#D6C7BA"/>
    <path opacity="0.5" d="M6.89904 22.5112C5.45784 22.5112 4.10664 21.9544 3.09504 20.9428C0.961439 18.8086 0.961439 15.3964 3.05844 13.2988L8.26644 8.09082L15.9104 15.7348L10.7024 20.9428C9.69084 21.9544 8.34024 22.5112 6.89904 22.5112Z" fill="#D6C7BA" fillOpacity="0.6"/>
  </svg>

);

export default SvgComponent;
